import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataExternalApi, NodeDataUpdateExternalApi, ProxyConfigBasic, PublicTraceEntry } from '@onefootprint/request-types/dashboard';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import useDirty from '@/components/playbook-builder/hooks/use-dirty';
import useOrgSession from '@/hooks/use-org-session';
import type { ApplyEditMutation } from '../../../base-node';
import type { ExternalApiFormData } from '../../types';
import ConfigurationSection from './components/configuration-section';
import ExternalApiContentForm from './components/external-api-content-form/external-api-content-form';
import LogsSection from './components/logs-section';
import { getDefaultValues } from './utils/get-default-values';
export type ExternalApiContentProps = {
  node: {
    id: string;
    data: ApiNodeDataExternalApi;
  };
  mutation: ApplyEditMutation;
  canEdit: boolean;
  traceEntry?: PublicTraceEntry;
  proxyConfig: ProxyConfigBasic | undefined;
  sandboxProxyConfig: ProxyConfigBasic | undefined;
  onSubmit?: (data: NodeDataUpdateExternalApi) => void; // For storybook testing
};
const ExternalApiContent = t0 => {
  const $ = _c(31);
  const {
    node,
    mutation,
    canEdit,
    traceEntry,
    proxyConfig,
    sandboxProxyConfig,
    onSubmit
  } = t0;
  const {
    sandbox
  } = useOrgSession();
  let t1;
  if ($[0] !== node || $[1] !== proxyConfig || $[2] !== sandbox.isSandbox || $[3] !== sandboxProxyConfig) {
    t1 = getDefaultValues({
      node,
      proxyConfig,
      sandboxProxyConfig,
      isSandboxSession: sandbox.isSandbox
    });
    $[0] = node;
    $[1] = proxyConfig;
    $[2] = sandbox.isSandbox;
    $[3] = sandboxProxyConfig;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const defaultValues = t1;
  const {
    toggle
  } = useDirty();
  const t2 = !canEdit;
  let t3;
  if ($[5] !== defaultValues || $[6] !== t2) {
    t3 = {
      disabled: t2,
      defaultValues
    };
    $[5] = defaultValues;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const formMethods = useForm(t3);
  const {
    formState: t4
  } = formMethods;
  const {
    isDirty
  } = t4;
  let t5;
  if ($[8] !== canEdit || $[9] !== isDirty || $[10] !== toggle) {
    t5 = () => {
      if (canEdit) {
        toggle("external-api-form", isDirty);
      }
    };
    $[8] = canEdit;
    $[9] = isDirty;
    $[10] = toggle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== canEdit || $[13] !== isDirty) {
    t6 = [isDirty, canEdit];
    $[12] = canEdit;
    $[13] = isDirty;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  useEffect(t5, t6);
  let t7;
  if ($[15] !== canEdit || $[16] !== mutation || $[17] !== node || $[18] !== onSubmit || $[19] !== proxyConfig || $[20] !== sandboxProxyConfig || $[21] !== traceEntry) {
    t7 = canEdit ? <ExternalApiContentForm node={node} mutation={mutation} canEdit={canEdit} onSubmit={onSubmit} /> : <ConfigurationSection node={node} isCollapsible={!!traceEntry} proxyConfig={proxyConfig} sandboxProxyConfig={sandboxProxyConfig} />;
    $[15] = canEdit;
    $[16] = mutation;
    $[17] = node;
    $[18] = onSubmit;
    $[19] = proxyConfig;
    $[20] = sandboxProxyConfig;
    $[21] = traceEntry;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== traceEntry) {
    t8 = traceEntry && <LogsSection traceEntry={traceEntry} />;
    $[23] = traceEntry;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = <div className="flex flex-col gap-4">{t7}{t8}</div>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== formMethods || $[29] !== t9) {
    t10 = <FormProvider {...formMethods}>{t9}</FormProvider>;
    $[28] = formMethods;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};
export default ExternalApiContent;